/** Round axis ticks: 0 first, last tick >= max, 1/2/5 x 10^n steps, integers only. */
export function niceTicks(max: number, count = 4): number[] {
  const m = Number.isFinite(max) && max > 1 ? max : 1;
  const raw = m / Math.max(1, count);
  const mag = 10 ** Math.floor(Math.log10(raw));
  const f = raw / mag;
  const step = Math.max(1, (f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10) * mag);
  const n = Math.ceil(m / step);
  return Array.from({ length: n + 1 }, (_, i) => i * step);
}

/** 2000 -> "2K", 1500 -> "1.5K", 800 -> "800". */
export function fmtCompact(v: number): string {
  return Math.abs(v) >= 1000 ? `${Number((v / 1000).toFixed(1))}K` : String(v);
}
